import React, { useEffect, useState } from 'react'
import { translate } from 'reducers/i18n'

import './digid.css'
import digidLogo from '../../../graphics/digid-logo.svg'
import { PageComponent } from 'components/page';


const DigiD = props => {
    const {authenticators, messageId, tenantId, query, hideLoginInstruction, mappings} = props
    const serviceProvider = authenticators[0]?.serviceProvider
    const [error, setError] = useState('');

    useEffect(() => {
        if(query.status === 'cancelled') {
            setError(translate('digid_cancelled'));
        } else if (query.status === 'unauthorised') {
            setError(translate('digid_unauthorised'));
        } else if (query.status === 'error') {
            setError(translate('digid_error'));
        }
    }, [query.status]);

    const login = () => {
        window.location.href = `${window.location.origin}/saml/login?RelayState=/edelivery/${tenantId}/messages/${messageId}`;
    }

    const snippets = {
        "service provider": serviceProvider || "Bastion 365"
    }

    return <>
        <div className="loginContentWithImage">
            <div>
                <PageComponent
                  noHeader={true}
                  content={mappings["E_DELIVERY_LOGIN_PAGE_DIGID"]}
                  snippets={snippets}
                  btnFunctions={[() => login()]}
                  disabled={false}
                />
            </div>
            <img src={digidLogo} alt="DigiD logo" className='m-3'/>
            {error && <div className="error">
                <p>{error}</p>
            </div>}
        </div>
    </>
}

export default DigiD
